
import { CoverSection } from '../components/carFiltersPage/coverSection/CoverSection';
import { MainSection } from '../components/carFiltersPage/mainSection/MainSection';

export function CarFiltersPage() {
  return (
    <>
      <CoverSection />
      <MainSection />
    </>
  );
}
